/* eslint camelcase: 0 */

import { Report as Data } from '@/typings/api/Report'
import { Model, createMessages } from '@/helpers/Model'


export class LKReportModel extends Model<Data> {
  public static readonly page_title = createMessages({
    ...Model.page_title,
    list: 'Отчеты',
  });

  public static readonly modal_delete = createMessages({
    ...Model.modal_delete,
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });
}
